"use client";
import { generalLiterals } from "../../literals";
import CurrencyRow from "components/earn/CurrencyRow";
import { useEffect, useMemo, useState } from "react";
import earnModule, { CurrencyGeneralData } from "logic/EarnModule";
import currenciesModule from "logic/CurrenciesModule";
import { handleErrors } from "errors";
import { useErrorAlert } from "logic/hooks";
import { ReserveState } from "contracts/UTokenFactoryContract";
import { VaultWarningToast } from "components/earn";
import { verisModule } from "clients/verisModule";

const {
  assetLabel,
  depositedLabel,
  apyLabel,
  balanceLabel,
  tvlLabel,
  utilzationRateLabel,
} = generalLiterals.earn;

const erc20Currencies = verisModule.networks
  .map((network) => currenciesModule.getErc20Currencies(network.CHAIN.id))
  .flat();

export default function Earn(): JSX.Element {
  const [error, setError] = useState<Error | null>(null);
  useErrorAlert(error);
  const [currenciesGeneralData, setCurrenciesGeneralData] =
    useState<CurrencyGeneralData[]>();

  // const erc20Currencies = useMemo<IErc20Currency[]>(
  //   () => currenciesModule.getErc20Currencies(chainId),
  //   [chainId]
  // );

  const nonActiveCurrencies = useMemo<string[] | null>(() => {
    if (currenciesGeneralData) {
      const nonActiveCurrencies = currenciesGeneralData.filter(
        ({ reserveState }) => reserveState !== ReserveState.ACTIVE
      );

      if (nonActiveCurrencies.length > 0) {
        return nonActiveCurrencies.map(({ label }) => label);
      }
    }
    return null;
  }, [currenciesGeneralData]);

  useEffect(() => {
    handleGetCurrenciesGeneralData();
  }, []);

  const handleGetCurrenciesGeneralData = async () => {
    try {
      const data = await Promise.all(
        erc20Currencies.map((currency) =>
          earnModule.getCurrencyGeneralData(currency, true)
        )
      );

      setCurrenciesGeneralData(data);
    } catch (err) {
      setError(handleErrors(err));
    }
  };

  return (
    <>
      {nonActiveCurrencies && (
        <VaultWarningToast
          className="mx-auto mb-[30px]"
          nonActiveCurrencies={nonActiveCurrencies}
        />
      )}
      <div className="max-w-7xl mx-auto p-0.5 border-unlockd rounded-xl">
        <div className="w-full p-4 relative bg-secondary rounded-xl">
          <table className="w-full text-base text-left text-white">
            <thead className="text-md">
              <tr>
                <th scope="col" className="py-3 px-[30px] text-left">
                  {assetLabel}
                </th>
                <th scope="col" className="py-3 pr-[30px] text-right">
                  {apyLabel}
                </th>
                <th scope="col" className="py-3 pr-[30px] text-right">
                  {tvlLabel}
                </th>
                <th scope="col" className="py-3 pr-[30px] text-right">
                  {utilzationRateLabel}
                </th>
                <th scope="col" className="py-3 pr-[30px] text-right">
                  {depositedLabel}
                </th>
                <th scope="col" className="py-3 pr-[30px] text-right">
                  {balanceLabel}
                </th>
              </tr>
            </thead>
            <tbody>
              {erc20Currencies.map((currency) => {
                const generalData = currenciesGeneralData?.find(
                  (_currency) => currency.id === _currency.id
                );

                return (
                  <CurrencyRow
                    key={currency.name + currency.chain.name}
                    currency={currency}
                    generalData={generalData}
                  />
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}
